import React from 'react';

import {
    useBreadCrumbItems,
    useBreadCrumbsFromPath,
} from '@src/hooks/breadCrumbs';

import Item from './BreadCrumbItem';
import LastItem from './BreadCrumbLastItem';
// import BreadCrumb from './BreadCrumb';
// import LastBreadCrumb from './LastBreadCrumb';

import styles from './breadcrumbs.scss';

const BreadCrumbs = () => {
    useBreadCrumbsFromPath();
    const items = useBreadCrumbItems();

    return (
        <div className={`${styles.bread_crumbs_container}`}>
            <nav className="breadcrumb">
                { items.slice(0, -1).map((i) => <Item key={i.url} title={i.title} url={i.url} />)}
                { items.slice(-1).map((i) => <LastItem key={i.url} title={i.title} />)}
            </nav>
        </div>
    );
};

export default React.memo(BreadCrumbs);
